import { Routes } from '@angular/router';
import { AuthGuard } from '@utils/guards/auth.guard';

export const subaccountsRoutes: Routes = [
  {
    path: 'clientes/nueva-subcuenta',
    loadComponent: () =>
      import('./create-subaccount.component').then(
        (component) => component.CreateSubaccountComponent,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'clientes/subcuentas',
    loadComponent: () =>
      import('./subaccounts-list.component').then(
        (component) => component.SubaccountsListComponent,
      ),
    canActivate: [AuthGuard],
  },
];
